import { initialState } from './allegati.state';
import * as allegatiActions from './allegati.actions';

/**
 * Funzione che gestisce le variazioni di stato a livello della sezione allegati secondo le diverse azioni disponibili
 * @param state {State} stato come definito per la sezione allegati, inizialmente valorizzato a initialState
 * @param action {AllegatiAction} le azioni disponibili per la sezione allegati
 */
export function allegatiReducer(state = initialState, action: allegatiActions.AllegatiAction) {
    switch(action.type) {
        case allegatiActions.START_FILTRI: {
            return {
                ...state,
                currentSection: action.payload.currentSection,
                filters: action.payload.filters
            };
        }
        case allegatiActions.CLEAR_FILTRI: {
            return {
                ...state,
                currentSection: 'none',
                filters: null
            }
        }
        default: {
            return {
                ...state
            };
        }
    }
}